import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import {
  ENTITY_GENERATION_FEATURE_OFF,
  EntityGenerationSourcesResponse,
} from 'src/app/models/home/entity-capabilities/home-entity-capabilities.model';
import { HOME_API_ROUTES } from './home-api-routes';

/**
 * Home IA · H12. Fuentes candidatas (documentos visibles) para generar un documento desde una
 * entidad. Gate `doc_generation`. ACL-safe en el backend: sólo devuelve fuentes que el usuario
 * puede ver. Ante 404 (feature off o entidad no visible) degrada a `featureAvailable=false` para
 * ocultar el botón, sin propagar el error. El resto de errores se propagan (los aísla el widget).
 * account/user por JWT. NUNCA dispara generación: sólo lista fuentes para la confirmación explícita.
 */
@Injectable({ providedIn: 'root' })
export class HomeEntityGenerationService {
  constructor(private readonly api: ApiService) {}

  getGenerationSources(entityId: string): Observable<EntityGenerationSourcesResponse> {
    return this.api
      .get<EntityGenerationSourcesResponse>(HOME_API_ROUTES.ENTITY_GENERATION_SOURCES(entityId))
      .pipe(
        catchError((error) => {
          if (error?.status === 404) {
            return of({ ...ENTITY_GENERATION_FEATURE_OFF, entityId });
          }
          return throwError(() => error);
        }),
      );
  }
}
